<template>
  <q-card
    dense
    class="license-dialog-container relative"
  >
    <q-card-section class="title">
      <div class="text-center ibf-h2">
        <slot name="dialogTitle"> License Release </slot>
      </div>
    </q-card-section>
    <q-card-section class="subtitle ibf-h6 app_text_grey text-center q-pa-none">
      <slot name="subtitle"> License will enter cooldown state, it will be <br />released within </slot>
    </q-card-section>
    <q-card-section
      dense
      class="waiting-large-img text-center q-pa-none"
    >
      <div class="background"></div>
      <div class="cooldown ibf-amount1">{{ dialogData.cooldown || 5 }}H</div>
    </q-card-section>

    <q-card-section class="button-container q-pa-none">
      <q-card-actions align="center">
        <q-btn
          v-close-popup
          flat
          no-caps
          class="deny-btn incredi-button-ibx secondary"
        >
          No, Thank you
        </q-btn>
        <q-btn
          v-close-popup
          flat
          no-caps
          class="incredi-button-ibx primary-strong"
          :disable="!(registerAgentList && Array.isArray(registerAgentList) && registerAgentList.length > 0)"
          @click="registerAgents"
        >
          Okay
        </q-btn>
      </q-card-actions>
    </q-card-section>
    <q-card-section class="bottom-pretty-bar q-pa-none">
      <div class="bottom-pretty-bar-second"></div>
    </q-card-section>
  </q-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { notify } from '@/services/notify/notify';
import { CONST_NOTIFY } from '@/services/notify/CONST';

export default {
  name: 'LicenseDialog',
  mixins: [notify],
  computed: {
    ...mapGetters({
      dialogData: ['main/dialogData'],
    }),
    registerAgentList() {
      return this.$store.getters['main/dialogData'].registerAgentList;
    },
  },
  methods: {
    async registerAgents() {
      if (this.registerAgentList && Array.isArray(this.registerAgentList) && this.registerAgentList.length > 0) {
        const promisesArr = [];
        this.registerAgentList.forEach(x => {
          x.action = 'licenseConfig';
          const promise = this.$store.dispatch('agents/registerAgent', x);
          promisesArr.push(promise);
        });
        Promise.all(promisesArr)
          .then(() => {
            this.toastMessage(`License has entered cool down state for ${this.dialogData.cooldown}H`, CONST_NOTIFY.MESSAGE_TYPE.WARNING);
          })
          .catch(() => {
            this.toastMessage('License has release exception', CONST_NOTIFY.MESSAGE_TYPE.ERROR);
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.license-dialog-container {
  position: relative;
  width: 432px;
  height: 282px;
  background: $-system-app-white;
  border-radius: 2px;
  .title {
    text-align: center;
    padding-top: 26px;
    padding-bottom: 11px;
  }
  .subtitle {
    line-height: 16.12px;
    padding-bottom: 13px;
  }
  .waiting-large-img {
    width: 100%;
    padding-bottom: 16px;
    .background {
      background: url('@/assets/images/icons/illu-waiting-large@3x.png') no-repeat;
      background-size: 100%;
      width: 38px;
      height: 39px;
      margin: auto;
    }
    .cooldown {
      height: 18px;
      line-height: 17px;
    }
  }
  .button-container {
    padding-bottom: 0px;
    .deny-btn {
      width: 130px;
    }
  }
  .bottom-pretty-bar {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 24px;
    background: linear-gradient(90deg, rgba(0, 240, 185, 0.859375) -3.46%, #00f0b9 10.68%, rgba(0, 240, 185, 0) 50.87%);
    opacity: 0.5;
    .bottom-pretty-bar-second {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 17px;
      background: $-brand-gradient;
      opacity: 0.8;
    }
  }
}

.success-dialog-container {
  position: relative;
  width: 432px;
  height: 282px;
  background: white;

  .bg-tilted {
    bottom: 0;
    left: 0;
    position: absolute;
    background: $-system-app-primary;
    height: 458px;
    width: 400px;
    clip-path: polygon(0% 28%, 100% 8.4%, 100% 100%, 0% 100%);
  }

  .bg-lines {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .small,
    .big {
      position: absolute;
      width: 100%;
      height: 5px;
    }

    .small {
      top: 367px;
      background: url('@/assets/images/dialog-boxes/line-small.png') no-repeat;
      background-position-x: right;
      background-position-y: top;
    }

    .big {
      top: 378px;
      background: url('@/assets/images/dialog-boxes/line-big.png') no-repeat;
      background-position-x: right;
      background-position-y: top;
    }
  }

  .title {
    //margin-top: 32px;
    padding: 0;
    font-family: Gordita-Bold;
    font-size: 32px;
    color: black;
  }

  .diamond {
    position: absolute;
    width: 180px;
    height: 144px;
    padding: 5px;
    left: calc(50% - 90px);
    top: 111px;

    .outline {
      top: 10px;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      background: url('@/assets/images/dialog-boxes/diamond-outline.png') no-repeat;
      background-size: 100%;
    }

    .background {
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      background: url('@/assets/images/dialog-boxes/diamond-white-bg.png') no-repeat;
      background-size: 100%;
    }

    .status-icon {
      width: 100%;
      height: 100%;
      background: url('@/assets/images/dialog-boxes/success.png') no-repeat;
      background-position: center;
    }
  }

  :deep(.subtitle) {
    position: absolute;
    padding: 0;
    width: 220px;
    top: 298px;
    left: calc(50% - 110px);
    text-align: center;
    color: white;
    font-family: Gordita-Regular;
    font-size: 20px;
    line-height: 27px;
    .subtitle-bold {
      font-family: Gordita-Bold;
    }
  }

  .button-container {
    padding: 0;
    margin: 0;
    position: absolute;
    top: 414px;
    //bottom: 55px;
    width: 100%;
  }

  .confirm-btn {
    min-width: 97px;
    background: white;
    border-radius: 30px;
  }
}
</style>
